import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from "./TextField";
import styled from "@emotion/styled";
import { colors } from "../theme";
import { useRef } from "react";
import { readableColor } from "polished";
export function SearchFieldFullWidth({ arrow, open, placeholder, desktop = false, searchIconPosition, searchTerm, onBlur, onSearch, }) {
    const inputRef = useRef(null);
    return (_jsx(Container, Object.assign({ arrow: arrow, desktop: desktop, open: open, iconPosition: searchIconPosition, onSubmit: e => {
            var _a, _b;
            e.preventDefault();
            onSearch((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "");
        } }, { children: _jsx(TextField, { ref: input => {
                if (input != null && open)
                    input.focus();
                inputRef.current = input;
            }, autoFocus: open, placeholder: placeholder, defaultValue: searchTerm, inputBorderColor: readableColor(colors.greyLight), onBlur: onBlur }, void 0) }), void 0));
}
const Container = styled.form(({ desktop, open, arrow = "right", iconPosition }) => {
    const arrowY = -6;
    const arrowX = iconPosition == null ? 0 : iconPosition.x + iconPosition.width / 2;
    return Object.assign(Object.assign({ alignItems: "center", backgroundColor: colors.greyLight, display: "grid", gridTemplateColumns: desktop ? "96rem" : "1fr", justifyContent: "center", padding: desktop ? "1.2rem 0 0.4rem" : "0.8rem 1.2rem", position: desktop ? "absolute" : open ? "relative" : "absolute", top: desktop ? "9.8rem" : "100%", transform: open ? "scaleY(1)" : "scaleY(0)", transformOrigin: "center top", transition: "transform 200ms ease-in-out", width: "100%" }, (desktop
        ? {
            left: "0",
            right: "0",
        }
        : {})), { "&:before": Object.assign({ color: colors.greyLight, content: "'\\25E2'", position: "fixed", transform: "rotate(-135deg)" }, (desktop
            ? {
                top: arrowY,
                left: arrowX,
            }
            : {
                top: "-0.6rem",
                [arrow]: "5.6rem",
            })) });
});
//# sourceMappingURL=SearchFieldFullWidth.js.map